import ViewBase from "../view-base.view";
import photoModel from "../../models/photo/photo.model";
import moment from "moment";
import { formats } from "../../config/constants";

/**
 * [TEMP] Type 2 Photo Download View
 * 
 * A temporary page for SME admin users to download type 2 photos of last 30 days
 * 
 * @author CV Leong
 */
export default function Type2PhotoDownloadView() {
  ViewBase.call(this);

  let isDownloading = false;

  // Temporarily hard-coded
  const requestBody = {
    fromDate: moment().add(-30, 'day').format(formats.apiDateFormat),
    toDate: moment().format(formats.apiDateFormat),
    siteIds: [""],
    siteGroupIds: [""],
    modelCodes: [""],
    GSCMDivisions: [""],
    promoterIds: [""]
  }

  const downloadPhotos = (e) => {
    e.preventDefault();
    isDownloading = true;

    photoModel.downloadType2Photos(requestBody)
      .catch((error) => {
        this.handleError(error);
      })
      .finally(() => {
        isDownloading = false;
      });
  }

  return {
    view: (vnode) => {
      return [
        m('.d-flex.flex-column.align-items-start.gap-2.mb-3',
          m('button.btn.btn-primary[type=button]', {
            disabled: isDownloading,
            onclick: downloadPhotos,
          },
            isDownloading
              ? m('span.spinner-border.spinner-border-sm.me-2[role=status][aria-hidden=true]')
              : m('i.bi.bi-file-earmark-arrow-down'),
            this.getText('LT00000492', 'Download')
          ),
          m('small.fst-italic', '* ', this.getText('', 'Photos of last 30 days only')),
        ),
        this.getBaseViews()
      ]
    }
  }
}